import type { SetPersistKeyAction } from './actions.types';

export const setPersistKey: (key: string) => SetPersistKeyAction = (key) => ({
  type: 'PERSIST_KEY.SET',
  payload: { key },
});
